declare namespace $ {

	type $mol_textarea__value_shm_hitalama_map_widget_float_chrome_telegram_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_chrome_telegram['field_value'] >
		,
		ReturnType< $mol_textarea['value'] >
	>
	export class $shm_hitalama_map_widget_float_chrome_telegram extends $shm_hitalama_map_widget_float_form_custom {
		rpc_listener( ): any
		require_id( ): any
		Textarea( id: any): $mol_textarea
		chat_id( next?: string ): string
		chat_title( next?: string ): string
		auto( ): readonly(any)[]
		Content_by_type_override( id: any): Record<string, any>
		Details_icon( ): $mol_icon_dots_horizontal
	}
	
}

//# sourceMappingURL=telegram.view.tree.d.ts.map